export default __webpack_public_path__ + "static/media/postgresql.b941b412.svg";